import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-pitahaya via-pitahaya-dark to-pitahaya text-white py-3 px-4 shadow-md" data-id="element-229" data-mp="3cvfrn8bsbgio">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-230" data-mp="37v1voongjx10">
        <motion.div animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="w-2.5 h-2.5 bg-gold-metallic rounded-full mr-3 flex-shrink-0 shadow-sm shadow-gold-metallic/50" data-id="element-231" data-mp="32wgr6d16ar6r" />
        <p data-id="element-232" data-mp="2p5v92qjjml9x">
          Registro abierto para el Webinar gratuito de Maximización de Capital |
          28 de Mayo, 2026 — 8pm (Hora CDMX).
        </p>
      </div>
    </div>;
}